import { Module } from '../../models/module.model';

export interface ModuleState {
  module: Module | null;
}

export const initialState: ModuleState = {
  module: null,
};
